import $ from "jquery";
import "lightbox2"

$(document).ready(function () {

    $('.ticket .btn-expand-info').on('click', function (event) {
        event.preventDefault();
        $(this).closest('.ticket').find('.collapsed-content').stop(true).slideToggle(400);
    });

    $('.quantity-selector').on('change', function (event) {
        let newTotal = (parseFloat($(this).attr('data-price').replace(',', ''))).toFixed(2) * (parseInt($(this).val()) + 1);
        $('.total_' + $(this).attr('data-id')).text($(this).attr('data-currency') + numberWithCommas(parseFloat(newTotal).toFixed(2)));
    });

    $('.cart-add-btn').on('click', function (e) {
        let selectInput = $(this).parents('.js-ticket-block').find('.quantity-selector');
        $('.form-qty').val(parseInt(selectInput.val()) + 1);
        $('.form-ticket-category').val(selectInput.attr('data-id'));
        $('#cart-add-form').submit();
    });
    if ($('#currencyModal').hasClass('show')) {
        $("#currencyModal").modal();
    }
    $('#modal-btn-si').on('click', function () {
        $('.js-override-cart').val(true);
        $('#cart-add-form').submit();
    });
    $('#modal-btn-no').on('click', function () {
        $("#currencyModal").modal('hide');
    });

});

function showDeliveryDetails(t) {
    $("#noticeModal .modal-body").html($(".delivery_info." + t).html()),
        $("#noticeModal").modal()
}
function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
